import Vue from 'vue'
import Vuetify from 'vuetify'

Vue.use(Vuetify)

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        themes: {
            light: {
                primary: '#0a3051',
                secondary: '#009bd9',
                highlight: "#296C9A",
                searchbar: "#005087",
                accent: '#85c9f0',
                error: '#f44336',
                success: '#176e4b',
                warning: '#a16c21',
            },
        },
    },
})


// WEBPACK FOOTER //
// ./src/plugins/vuetify.js